var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopShortMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 3,
  viewBox: "0 0 15 3",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 1.5C3 2.33 2.33 3 1.5 3S0 2.33 0 1.5.67 0 1.5 0 3 .67 3 1.5M7.5 0C6.67 0 6 .67 6 1.5S6.67 3 7.5 3 9 2.33 9 1.5 8.33 0 7.5 0m6 0c-.83 0-1.5.67-1.5 1.5S12.67 3 13.5 3 15 2.33 15 1.5 14.33 0 13.5 0"
})));
export default SvgYoutubeDesktopShortMore;